import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <motion.div
      className="nf-root"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.35 }}
    >
      <div className="nf-panel">
        <div className="nf-deco" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <div className="nf-badge">
          <i className="bx bx-error-circle" />
          Error 404
        </div>

        <h1 className="nf-code">404</h1>
        <h2 className="nf-title">This page could not be found</h2>
        <p className="nf-text">
          The link might be broken, or the page may have been moved. Double-check
          the URL or head back to your dashboard — like picking the right server
          zone, sometimes you just need the right route.
        </p>

        <div className="nf-actions">
          <button
            type="button"
            className="nf-btn nf-btn-primary"
            onClick={() => navigate("/dashboard")}
          >
            <i className="bx bx-home-alt" />
            Back to dashboard
          </button>
          <button
            type="button"
            className="nf-btn nf-btn-ghost"
            onClick={() => navigate(-1)}
          >
            <i className="bx bx-arrow-back" />
            Go back
          </button>
        </div>

        <p className="nf-hint">
          Requested path: <code>{location.pathname || "/"}</code>
        </p>
      </div>
    </motion.div>
  );
};

export default NotFound;
